// Desktop-only: center sticky details container vertically in available viewport space
(() => {
  const CONTAINER_SEL = '.product-inner .product__details.sticky-details-container';
  const HEADER_SEL = '.header-wrapper > header';
  const DESKTOP_MIN = 1024;

  const outerHeight = (el) => (el ? el.getBoundingClientRect().height : 0);

  const applyStickyPadding = () => {
    const container = document.querySelector(CONTAINER_SEL);
    if (!container) return;
    if (window.innerWidth < DESKTOP_MIN) {
      container.style.paddingTop = '';
      // container.style.paddingBottom = '';
      return;
    }

    const header = document.querySelector(HEADER_SEL);

    const viewportH = window.innerHeight || document.documentElement.clientHeight;
    const headerH = outerHeight(header);
    const containerH = outerHeight(container);

    const available = viewportH - 140;

    // ((available - containerH) / 2)
    const pad = Math.max(0, Math.floor((available - containerH) / 2));

    container.style.paddingTop = `${pad}px`;
  };

  // debounce
  let t;
  const schedule = () => {
    clearTimeout(t);
    t = setTimeout(applyStickyPadding, 80);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyStickyPadding);
  } else {
    applyStickyPadding();
  }

  window.addEventListener('resize', schedule, { passive: true });

  window.addEventListener('scroll', schedule, { passive: true });
})();
